import { __decorate } from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import LoadingSpinner from "@/components/Utils/LoadingSpinner.vue";
let ListLoading = class ListLoading extends Vue {
    loading;
    search;
    count;
    spinnerClass;
};
__decorate([
    Prop({ type: Boolean, required: true })
], ListLoading.prototype, "loading", void 0);
__decorate([
    Prop({ type: Boolean })
], ListLoading.prototype, "search", void 0);
__decorate([
    Prop({ type: Number, required: true })
], ListLoading.prototype, "count", void 0);
__decorate([
    Prop({ type: String })
], ListLoading.prototype, "spinnerClass", void 0);
ListLoading = __decorate([
    Component({
        components: { LoadingSpinner }
    })
], ListLoading);
export default ListLoading;
